export default __webpack_public_path__ + "static/media/mol_card_1.d1b02643.png";